export default __webpack_public_path__ + "static/media/Pipeline.54875427.jpg";